import * as React from "react";
import { withRouter } from "react-router";
import { get } from "lodash";
import { History } from "history";
// UI Frameworks
import { Steps } from "antd";
// Local Components
import FirstStep from "./components/FirstStep";
import ThirdStep from "./components/ThirdStep";
import SecondStep from "./components/SecondStep";
import Maybe from "components/Maybe";
// Styles
import styles from "./index.module.scss";

interface IState {
	unit: number;
	current: number;
	affordableAssets: number;
	diff: number;
	sellPrice: number;
}
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IAction extends Partial<IState> {}

const initialState = (unit?: any) => ({ unit: unit | 0, current: 0, affordableAssets: 0, diff: 0 } as IState);
function reducer(state: IState, action: IAction): IState {
	return { ...state, ...action };
}

interface IContextProps {
	state: IState;
	dispatch: any;
}

interface IProps {
	history: History;
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
const IssueContext = React.createContext({ state: initialState(), dispatch: () => {} } as IContextProps);
const { Step } = Steps;

const BuyGold: React.FC<IProps> = (props) => {
	const [store, dispatch] = React.useReducer(reducer, initialState(get(props.history.location, ["query", "unit"])));

	return (
		<div className="container">
			<div className={styles["steps-box"]}>
				<div className={styles["steps-box__steps"]}>
					<Steps current={store.current}>
						<Step />
						<Step />
						<Step />
					</Steps>
				</div>

				<IssueContext.Provider value={{ state: store, dispatch }}>
					<div className={styles["main__content"]}>
						<Maybe condition={store.current === 0}>
							<FirstStep />
						</Maybe>
						<Maybe condition={store.current === 1}>
							<SecondStep />
						</Maybe>
						<Maybe condition={store.current === 2}>
							<ThirdStep />
						</Maybe>
					</div>
				</IssueContext.Provider>
			</div>
		</div>
	);
};
export const useIssue = () => React.useContext(IssueContext);

export default withRouter(BuyGold);
